export default {"src":"/_next/static/media/IONQ.83faac64.svg","height":18,"width":18};